// frontend/src/components/Requisitions/edit/hooks/useAdminProfile.js

import { useEffect, useMemo, useState } from "react";

import { fetchMeFirstOk } from "../api";
import { getUserAccess } from "../../../../utils/userPermissions";

function isAdminLike(me) {
  if (!me) return false;
  const access = getUserAccess(me);
  return access.canAccessAdmin;
}

export function useAdminProfile() {
  const [me, setMe] = useState(null);
  const [loadingMe, setLoadingMe] = useState(false);

  const adminLike = useMemo(() => isAdminLike(me), [me]);

  useEffect(() => {
    let cancelled = false;

    async function loadMe() {
      setLoadingMe(true);
      try {
        const data = await fetchMeFirstOk();
        if (!cancelled) {
          setMe(data);
        }
      } finally {
        if (!cancelled) {
          setLoadingMe(false);
        }
      }
    }

    loadMe();

    return () => {
      cancelled = true;
    };
  }, []);

  return {
    me,
    loadingMe,
    adminLike,
  };
}